<template>
  <section class="reviews-section" aria-labelledby="reviews-heading">
    <div class="max-w-screen-xl mx-auto px-6">

      <!-- Header -->
      <div class="reviews-header">
        <span class="reviews-eyebrow">Klantreviews</span>
        <h2 id="reviews-heading" class="reviews-title">Wat onze klanten zeggen</h2>
      </div>

      <!-- Review kaartjes -->
      <div class="reviews-grid">
        <div v-for="review in reviews" :key="review.id" class="review-card">
          <!-- Stars + datum -->
          <div class="review-top">
            <div class="review-stars">
              <i v-for="s in review.stars" :key="s" class="bi bi-star-fill"></i>
              <i v-for="s in (5 - review.stars)" :key="'e'+s" class="bi bi-star"></i>
            </div>
            <span class="review-date">{{ review.date }}</span>
          </div>
          <!-- Tekst -->
          <p class="review-text">"{{ review.text }}"</p>
          <!-- Reviewer (anoniem) -->
          <div class="review-author">
            <div class="review-avatar"><i class="bi bi-person-fill"></i></div>
            <div>
              <span class="review-name">Anonieme klant</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script setup>
// Anonieme voorbeeldreviews (geen namen, geen externe bron).
const reviews = [
  {
    id: 1,
    stars: 5,
    date: 'april 2025',
    text: 'Laadpaal snel geleverd en makkelijk te installeren. Goede communicatie en snelle levering, echt een aanrader voor iedereen die wil overstappen op elektrisch rijden.',
  },
  {
    id: 2,
    stars: 5,
    date: 'maart 2025',
    text: 'Zonnepanelen besteld, volgende dag al bezorgd. Installateur was zeer vakkundig. Al na één week merk ik duidelijk verschil op de energierekening. Super tevreden!',
  },
  {
    id: 3,
    stars: 5,
    date: 'februari 2025',
    text: 'Uitstekende service. Had een vraag over de thuisbatterij en werd dezelfde dag nog geholpen door een technisch expert. Prijs-kwaliteit is top.',
  },
]
</script>

<style scoped>
.reviews-section {
  background: #111;
  padding: 4rem 0 4.5rem;
  position: relative;
  overflow: hidden;
}

/* Subtiele achtergrondtextuur */
.reviews-section::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse 80% 60% at 50% 0%, rgba(255,213,0,0.06) 0%, transparent 60%);
  pointer-events: none;
}

/* ── Header ── */
.reviews-header {
  text-align: center;
  margin-bottom: 3rem;
}

.reviews-eyebrow {
  display: inline-block;
  background: rgba(255,213,0,0.15);
  color: #FFD500;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 0.3rem 1rem;
  border-radius: 50px;
  border: 1px solid rgba(255,213,0,0.25);
  margin-bottom: 1rem;
}

.reviews-title {
  font-size: clamp(1.625rem, 3.5vw, 2.25rem);
  font-weight: 900;
  color: #fff;
  margin: 0 0 1.75rem;
  line-height: 1.1;
}

/* Score rij */
.reviews-score-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.reviews-score-badge {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 12px;
  padding: 0.625rem 1.125rem;
}

.score-number {
  font-size: 1.75rem;
  font-weight: 900;
  color: #fff;
  line-height: 1;
}

.score-stars {
  display: flex;
  gap: 2px;
}
.score-stars i { font-size: 0.85rem; color: #FFD500; }

.score-label {
  font-size: 0.85rem;
  font-weight: 700;
  color: #FFD500;
  border-left: 1px solid rgba(255,255,255,0.15);
  padding-left: 0.75rem;
  margin-left: 0.25rem;
}

.reviews-score-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
}

.tp-logo {
  height: 22px;
  object-fit: contain;
  opacity: 0.9;
}

.score-count {
  font-size: 0.82rem;
  color: rgba(255,255,255,0.5);
}
.score-count strong { color: rgba(255,255,255,0.8); }

.tp-link {
  font-size: 0.82rem;
  font-weight: 600;
  color: #00B67A;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  transition: gap 0.15s;
}
.tp-link:hover { gap: 0.5rem; }

/* ── Review kaartjes ── */
.reviews-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.25rem;
  margin-bottom: 2.5rem;
}

@media (max-width: 900px) { .reviews-grid { grid-template-columns: 1fr; } }
@media (min-width: 640px) and (max-width: 900px) { .reviews-grid { grid-template-columns: repeat(2, 1fr); } }

.review-card {
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 16px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  transition: border-color 0.2s, background 0.2s;
}
.review-card:hover {
  border-color: rgba(255,213,0,0.3);
  background: rgba(255,255,255,0.07);
}

.review-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.review-stars { display: flex; gap: 2px; }
.review-stars i { font-size: 0.8rem; color: #FFD500; }
.review-stars .bi-star { color: rgba(255,255,255,0.2); }

.review-date {
  font-size: 0.72rem;
  color: rgba(255,255,255,0.35);
}

.review-text {
  font-size: 0.9rem;
  color: rgba(255,255,255,0.8);
  line-height: 1.65;
  flex: 1;
  margin: 0;
  font-style: italic;
}

.review-author {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding-top: 0.875rem;
  border-top: 1px solid rgba(255,255,255,0.08);
}

.review-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #FFD500;
  color: #111;
  font-weight: 800;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.review-name {
  display: block;
  font-size: 0.82rem;
  font-weight: 700;
  color: #fff;
}

.review-verified {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.7rem;
  color: #00B67A;
  margin-top: 1px;
}
.review-verified i { font-size: 0.7rem; }

/* ── CTA ── */
.reviews-cta { text-align: center; }

.reviews-cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.625rem;
  background: #00B67A;
  color: #fff;
  font-weight: 700;
  font-size: 0.9375rem;
  padding: 0.875rem 2rem;
  border-radius: 10px;
  text-decoration: none;
  transition: background 0.2s, transform 0.2s;
  box-shadow: 0 4px 16px rgba(0,182,122,0.3);
}
.reviews-cta-btn:hover {
  background: #009962;
  transform: translateY(-2px);
}

@media (prefers-reduced-motion: reduce) {
  .review-card, .reviews-cta-btn { transition: none; }
}
</style>
